export default __webpack_public_path__ + "static/retail-store-15db5caa24d13e639026e5d6dc073fb3.jpeg";